export { getIsPortraitOrientation } from "powerhooks/ViewPortAdapter";

export const breakpointsValues = {
    "sm": 600,
    "md": 960,
    "lg": 1280,
    "xl": 1920,
} as const;
